import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink, RouterOutlet } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LoggedUser } from './auth/interfaces/logged-user';
import { AuthService } from './auth/services/auth.service';
import { HeaderComponent } from './shared/components/header/header.component';
import { CommonModule } from '@angular/common';
import { Roles } from './constants/roles';

@Component({
  selector: 'app-root',
  imports: [
    HeaderComponent,
    MatButtonModule,
    MatSidenavModule,
    RouterOutlet,
    RouterLink,
    MatListModule,
    MatIcon,
    CommonModule
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  loggedUser: LoggedUser | null = null;
  sideNavElements = [
    { name: 'Home', icon: 'home', route: '/home' },
    { name: 'Ventas', icon: 'sell', route: '/studySells' },
    { name: 'Clientes', icon: 'person', route: '/customers' },
    { name: 'Estudios', icon: 'book', route: '/studies' },
    { name: 'Proyecciones', icon: 'light', route: '/studyProjections' },
    { name: 'Configuracion Estudios', icon: 'widgets', route: '/studyConfigs' },
    { name: 'Materiales', icon: 'inbox', route: '/materials' },
    { name: 'Dashboard', icon: 'monitoring', route: '/dashboard', roles: [Roles.ADMIN] },
    { name: 'Sistema', icon: 'settings', route: '/configuration' }
  ]

  constructor(readonly authService: AuthService) {
  }

  decodeToken() {
    this.authService.getTokenNoAsync().then(token => {
      this.loggedUser = jwtDecode(token);
      this.authService.setLoggedUserOnSessionStorage(token);
    });
  }

  ngOnInit(): void {
    this.decodeToken();
  }
}
